import {
  InteractionStepType,
  InteractionStepConfig,
  IndexedInteractionStepResponse,
  StepParamsForType,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';
import { IMultiTurnThreadHistory } from '../../ThreadHistory.interface';
import { SpanFeedbackConfigurationComponent } from './SpanFeedbackConfigurationComponent';

import { schema } from './validation';
import StepDescriptor from '../stepDescriptor/StepDescriptor';
import SpanFeedbackViewComponent from './SpanFeedbackViewComponent';
import SpanFeedbackPinnedViewComponent from './SpanFeedbackPinnedViewComponent';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';
import { ReviewLevel } from '@scale/shared-types';

export class SpanFeedbackDescriptor extends StepDescriptor<InteractionStepType.SpanFeedback> {
  type = InteractionStepType.SpanFeedback;
  title = InteractionStepConfig[InteractionStepType.SpanFeedback].title;
  description = InteractionStepConfig[InteractionStepType.SpanFeedback].description;

  validationSchema = schema;

  ViewComponent = SpanFeedbackViewComponent;
  PinnedViewComponent = SpanFeedbackPinnedViewComponent;
  ConfigurationComponent = SpanFeedbackConfigurationComponent;

  getResponseTemplatePaths(
    _stepParams: StepParamsForType<InteractionStepType.SpanFeedback>,
    _history: IMultiTurnThreadHistory,
  ) {
    return [];
  }

  isResponseValid(
    _response: IndexedInteractionStepResponse,
    _stepParams: StepParamsForTypeWithStage<InteractionStepType.SpanFeedback>,
    _history: IMultiTurnThreadHistory,
    _reviewLevel?: ReviewLevel,
  ) {
    return { canSubmit: true, submitTooltip: '' };
  }

  generateEmptyResponse(
    _stepParams: StepParamsForType<InteractionStepType.SpanFeedback>,
    history: IMultiTurnThreadHistory,
  ) {
    return {
      type: InteractionStepType.SpanFeedback,
      context: {},
      output: history.getMostRecentResponse(),
    };
  }

  getConfigurationPreviewTags() {
    return [];
  }
}

registerStepDescriptor({
  type: InteractionStepType.SpanFeedback,
  descriptor: new SpanFeedbackDescriptor(),
});
